module.exports = __webpack_public_path__ + "img/gb-wls.604791ed.svg";